import { __rest, __assign } from 'tslib';
import { jsxs, jsx } from 'react/jsx-runtime';

var ArrowDownOutlineIcon = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (jsxs("svg", __assign({ width: "1em", height: "1em", viewBox: "0 0 24 24", fill: "none", "data-ui-icon": true }, props, { children: [title ? jsx("title", { children: title }) : null, jsx("path", { d: "M12 22c-.26-.01-.56-.12-.75-.3l-6.91-6.668c-.452-.389-.443-1.138-.035-1.575.408-.438 1.13-.474 1.536-.033l5.068 4.884V3.11C10.91 2.497 11.398 2 12 2s1.09.497 1.09 1.111v15.197l5.07-4.884c.404-.44 1.13-.405 1.538.033.408.438.41 1.197-.039 1.576l-6.909 6.666A1.051 1.051 0 0112 22z", fill: "currentColor" })] })));
};

export { ArrowDownOutlineIcon };
//# sourceMappingURL=ArrowDownOutlineIcon.js.map
